import { css } from './lit.js';

/**
 * Styles for rendered Markdown, which renders into `.markdown-body`. A port of
 * the community portal's `MARKDOWN_STYLES`, so the poll preview here sizes
 * headings, lists, code and images the way the portal will.
 */
export const MARKDOWN_STYLES = css`
    .markdown-body > *:last-child {
        margin-bottom: 0;
    }
    .markdown-body h1,
    .markdown-body h2,
    .markdown-body h3 {
        font-size: 1.1rem;
        font-weight: 600;
        margin-top: 1rem;
    }
    .markdown-body h4,
    .markdown-body h5,
    .markdown-body h6 {
        font-size: 1rem;
        font-weight: 600;
        margin-top: 1rem;
    }
    .markdown-body ul,
    .markdown-body ol {
        padding-left: 1.5rem;
    }
    .markdown-body code {
        background: var(--bs-secondary-bg, rgba(0, 0, 0, 0.06));
        padding: 0.1em 0.3em;
        border-radius: 0.2rem;
        font-size: 0.9em;
    }
    .markdown-body img {
        max-width: 100%;
        height: auto;
    }
    /* Long tokens — URLs, stack frames — must not widen the card. */
    .markdown-body {
        overflow-wrap: anywhere;
    }
`;
